var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-routes-list"},[(_vm.routes.length)?_c('ul',{staticClass:"pt-routes-list__items"},_vm._l((_vm.routes),function(item){return _c('routes-item',{key:item.id,attrs:{"item":item}})}),1):_c('div',{staticClass:"pt-routes-list__nodata"},[_c('r-text',{attrs:{"type":"caption"}},[_vm._v(" Список пуст ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }